import "./people-list.component.css"
import { Remarkable } from "remarkable"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const PeopleListComponent = (props) => {
  const { id, Heading, People } = props
  const md = new Remarkable()

  return (
    <div className={`dagger-people-list people-list-${id}`}>
      <h2>{Heading}</h2>
      {People?.length > 0 && (
        <ul>
          {People.map((p) => {
            const { Media, Name, Title, Bio } = p

            return (
              <li key={p.id}>
                <div className="people-image-container">
                  <StrapiImageComponent attributes={Media.data.attributes} sizes="(max-width: 600px) 50vw, 45vw" />
                </div>
                <div className="people-info-container">
                  <h4>
                    {Name}, {Title}
                  </h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: md.render(Bio),
                    }}
                  />
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default PeopleListComponent
